/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MutateTextFileInput = {|
  id?: ?string,
  text: string,
  clientMutationId?: ?string,
|};
export type FileViewsTextMutationVariables = {|
  input: MutateTextFileInput
|};
export type FileViewsTextMutationResponse = {|
  +updateText: ?{|
    +file: ?{|
      +id: string,
      +name: ?string,
      +path: ?string,
      +text: ?string,
      +yaml: ?any,
    |}
  |}
|};
export type FileViewsTextMutation = {|
  variables: FileViewsTextMutationVariables,
  response: FileViewsTextMutationResponse,
|};
*/


/*
mutation FileViewsTextMutation(
  $input: MutateTextFileInput!
) {
  updateText(input: $input) {
    file {
      id
      name
      path
      text
      yaml
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MutateTextFilePayload",
    "kind": "LinkedField",
    "name": "updateText",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "file",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "path",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "yaml",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileViewsTextMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FileViewsTextMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "35447abed42f39920cd794b70dd4f3be",
    "id": null,
    "metadata": {},
    "name": "FileViewsTextMutation",
    "operationKind": "mutation",
    "text": "mutation FileViewsTextMutation(\n  $input: MutateTextFileInput!\n) {\n  updateText(input: $input) {\n    file {\n      id\n      name\n      path\n      text\n      yaml\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fbe65eab82f1367041823b9c4dbbd96f';

module.exports = node;
